// messageServices.js

import axios from 'axios';
import { API_BASE_URL } from '../utils/constants';


// The constant is correctly defined here as API_BASE_URL
 // Added /api for consistency

const api = axios.create({
  // Use API_BASE_URL
  baseURL: API_BASE_URL, 
  headers: {
    'Content-Type': 'application/json'
  }
});

api.interceptors.request.use(
  (config) => {
    // 🏆 FIX 1: Use the correct token key 'gigship_token'
    const token = localStorage.getItem('gigship_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // 🏆 FIX 2: Remove the expired token using the correct key
      localStorage.removeItem('gigship_token'); 
      
      // 🏆 FIX 3: REMOVE HARD REDIRECT! 
      // The AuthContext's global interceptor or the calling Redux thunk 
      // (in messagesSlice.js) should be responsible for proper logout/navigation.
      // window.location.href = '/login'; // <--- This line must be gone.
    }
    return Promise.reject(error); // Propagate the error to the calling function
  }
);

const messageService = {
  sendMessage: async (messageData) => {
    try {
      const response = await api.post('/messages', messageData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to send message' };
    }
  },

  getConversation: async (userId, params = {}) => {
    try {
      const queryParams = new URLSearchParams();
      if (params.page) queryParams.append('page', params.page);
      if (params.limit) queryParams.append('limit', params.limit);
      if (params.orderId) queryParams.append('orderId', params.orderId);
      
      const response = await api.get(`/messages/conversation/${userId}?${queryParams.toString()}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch conversation' };
    }
  },

  getConversations: async () => {
    try {
      const response = await api.get('/messages/conversations');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to fetch conversations' };
    }
  },

  markAsRead: async (messageId) => {
    try {
      const response = await api.patch(`/messages/${messageId}/read`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to mark as read' };
    }
  },

  deleteMessage: async (messageId) => {
    try {
      const response = await api.delete(`/messages/${messageId}`);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to delete message' };
    }
  },

  getUnreadCount: async () => {
    try {
      const response = await api.get('/messages/unread/count');
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to get unread count' };
    }
  },

  uploadAttachment: async (file) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      
      const response = await api.post('/upload/message', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Failed to upload file' };
    }
  }
};

export default messageService;